import DialogButton from './Button';
import DialogContainer from './Container';
import DialogContent from './Content';
import DialogDescription from './Description';
import DialogFooter from './Footer';
import DialogText from './Text';
// import DialogInput from './Input';
// import DialogSwitch from './Switch';
import DialogTitle from './Title';

export default {
  Button: DialogButton,
  Container: DialogContainer,
  Content: DialogContent,
  Description: DialogDescription,
  Footer: DialogFooter,
  // Input: DialogInput,
  // Switch: DialogSwitch,
  Text: DialogText,
  Title: DialogTitle,
};
